module.exports = __webpack_public_path__ + "img/400.64109c64.png";